import { ProductModel } from "./product.model";
import { BotanicInfoModel } from "./botanicinfo.model";
import { MeasureInfoModel } from "./measureinfo.model";

export class ProductInfoModel {
    public variety: ProductModel;
    public botanic: BotanicInfoModel[];
    public measures: MeasureInfoModel[];

    constructor(value: JSON) {
        if(value["variety"]) {
            this.variety = new ProductModel(value["variety"]);
        }
        if(value["botanic"]) {
            this.botanic = [];
            for(const info of value["botanic"]) {
                this.botanic.push(new BotanicInfoModel(info));
            }
        }
        if(value["measures"]) {
            this.measures = [];
            for(const info of value["measures"]) {
                this.measures.push(new MeasureInfoModel(info));
            }
        }
    }
}